export interface CustomFieldDataType {
    ID: number;
    Description: string;
    Format: string;
   }

export enum CustomFieldDataTypeEnum {
    AlphaNumeric = 1,
    Decimal = 3,
    Date = 4,
    Telephone = 5,
    // LunchPin = 6,
    // ID = 7,
    // StateID = 8,
    // SSN = 9,
    // GradeLevel = 10,
    Email = 11,
    Integer = 12,
    Datetime = 13,
    Time = 14,
    YesNo = 15
}